import { ArrowLink, Section, SectionHeader } from '@/components/ui/primitives';
import { RoomCard } from '@/components/rooms/RoomCard';
import { useRooms } from '@/lib/queries';
import { useI18n } from '@/lib/i18n';

export function PracticeRoomsSection(): React.JSX.Element {
  const { t } = useI18n();
  const { data, isPending } = useRooms();

  return (
    <Section midnight>
      <SectionHeader
        midnight
        overline={t('rooms.overline')}
        title={t('rooms.title')}
        action={
          <ArrowLink to="/practice-rooms" midnight>
            {t('rooms.seeAll')}
          </ArrowLink>
        }
      />

      <p className="mt-8 max-w-[42rem] text-body-lg text-on-midnight-muted">{t('rooms.sub')}</p>

      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {isPending
          ? Array.from({ length: 3 }, (_, i) => (
              <div key={i} className="h-[26rem] animate-pulse rounded-lg bg-midnight-raised" />
            ))
          : data?.slice(0, 3).map((room) => <RoomCard key={room.id} room={room} />)}
      </div>
    </Section>
  );
}
